import type { ResponseReadAll } from "epsm-api-types";
import { Converter } from "epsm-api-types/converter";
import type { Company } from "epsm-api-types/models";
import { BaseService } from "@/services/BaseService";
import { HttpClient, type IHttpClient } from "@/services/HttpClient";
import type { IReadAllParams } from "@/services/RequestParams";

export class CompanyService extends BaseService<Company, Company> {
	private constructor(private httpClient: IHttpClient) {
		super(new Converter());
	}

	private static instance: CompanyService;

	static create() {
		if (!CompanyService.instance) {
			CompanyService.instance = new CompanyService(HttpClient.create());
		}
		return CompanyService.instance;
	}

	async getData(
		params: Readonly<IReadAllParams>,
	): Promise<ResponseReadAll<Company>> {
		const response = await this.httpClient.get<ResponseReadAll<Company>>(
			"/companies",
			{
				params: {
					...this.getQueryParams(params),
				},
			},
		);
		return this.getResponseReadAll(response, params?.types);
	}
}
